module.exports = __webpack_public_path__ + "static/media/besties-oreo.11e449f9.svg";